import { useRef, useEffect, useCallback } from 'react'
import { Box, Tooltip } from '@mui/material'

// Linha horizontal de resize entre linhas de gráficos. Arrastar para baixo/cima
// ajusta a altura APENAS da linha imediatamente acima (a linha de baixo não é
// afetada). O valor é gerido e persistido por quem a usa.
export default function RowResizer({ value, onChange, min = 150, max = 1000 }) {
  const drag = useRef(null)

  const onMove = useCallback((e) => {
    if (!drag.current) return
    const dy = e.clientY - drag.current.y
    onChange(Math.max(min, Math.min(max, drag.current.v + dy)))
  }, [onChange, min, max])

  const onUp = useCallback(() => { drag.current = null; document.body.style.userSelect = '' }, [])

  useEffect(() => {
    window.addEventListener('mousemove', onMove)
    window.addEventListener('mouseup', onUp)
    return () => {
      window.removeEventListener('mousemove', onMove)
      window.removeEventListener('mouseup', onUp)
    }
  }, [onMove, onUp])

  const onDown = (e) => { drag.current = { y: e.clientY, v: value }; document.body.style.userSelect = 'none' }

  return (
    <Tooltip title="Drag to resize the charts above" placement="top">
      <Box
        onMouseDown={onDown}
        sx={{
          height: 16, cursor: 'ns-resize', display: 'flex', alignItems: 'center', gap: 1, px: 0.5,
          '&:hover .line': { borderColor: 'primary.main' },
          '&:hover .grip': { bgcolor: 'primary.main' },
        }}
      >
        <Box className="line" sx={{ flex: 1, borderTop: '1px dashed', borderColor: 'divider' }} />
        <Box className="grip" sx={{ width: 36, height: 3, borderRadius: 2, bgcolor: 'divider' }} />
        <Box className="line" sx={{ flex: 1, borderTop: '1px dashed', borderColor: 'divider' }} />
      </Box>
    </Tooltip>
  )
}
